import { Group, Image, Paper, Text } from '@mantine/core'
import MilestoneLogo from '@/assets/integrations/milestone.png'

export const MilestoneHeader = () => {
  return (
    <Paper bg="gray.1" p="md">
      <Group align="center" wrap="nowrap" gap="sm">
        <Image src={MilestoneLogo} w={36} h={36} fit="contain" />

        <Text fw="bold" size="sm">
          Milestone
        </Text>
      </Group>
    </Paper>
  )
}
